import { render } from "./Import.vue?vue&type=template&id=4c18298c&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=4c18298c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4c18298c"

export default script